module.exports = __webpack_public_path__ + "static/media/s16.316358ae.webp";